export enum AuthStorageKey {
    ACCESS_TOKEN = 'auth:accessToken',
    TOKEN_TYPE = 'auth:tokenType',
    EXPIRES_AT = 'auth:expiresAt',
}

/**
 * The raw response shape for the client-credentials grant authentication performed
 * with the APIs OAuth server.
 */
export interface ClientCredentialsAuthResponse {
    access_token: string
    expires_in: number
    token_type: string
}
/**
 * Note that we are using the same interface as the AuthPayload type from the GraphQL API schema.
 * We just transform the keys to CamelCase as we are used to work with that in the frontend.
 * We create new value called expiresAt which is a Date.
 */
export interface AuthState {
    readonly accessToken: string
    readonly tokenType: string
    readonly expiresAt: Date
}
